import { z } from "zod"

export function getPaginatedNodesSchema<TSchema extends z.ZodType>(
    nodeSchema: TSchema,
    minLength?: number
) {
    let edgesSchema = z.array(z.object({ node: nodeSchema }).required())

    if (minLength) {
        edgesSchema = edgesSchema.min(minLength)
    }

    return z
        .object({ edges: edgesSchema })
        .transform((value) => value.edges.map((edge) => edge.node))
}
